import React from 'react';
import SubmissionDetails from '../../../SubmissionDetails';
import s from './Poll.scss';
export const PollDetails = ({ deviation: { poll  } , deviation  })=>{
    if (!poll) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(SubmissionDetails, {
        deviation: deviation,
        className: s['details']
    }));
};
PollDetails.displayName = 'PollDetails';
export default PollDetails;
